module.exports = __webpack_public_path__ + "img/SSCorporateLogo.234f4327.png";